// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;
  var CommonMessages = require('share/messages/Izenda.CommonMessages');
  var querySourceTypeConstants = require('logic/data/Izenda.QuerySourceTypeConfig');
  var uiState = require('logic/Izenda.UiState');
  var localizer = require('share/localization/Izenda.Localizer');
  const { curry } = require('lodash/fp');

  var actions = compose(
    withState('searchProperty', 'updateSearchProperty', 'All'),
    withState('searchValue', 'updateSearchValue', ''),
    withState('isLoading', 'updateLoading', true),
    withHandlers({
      isNotHighLight:  curry(isNotHighLight),
      onSave        :  curry(onSave),
      onSearch      :  curry(onSearch),
      onCancel      :  curry(onCancel)
    })
  );

  function onSave (props, event) {
    var store = props.store;
    var loader = props.loader;
    var valManager = props.validation;

    if (!store.canSave) {
      store.alertMessage = {type: CommonMessages.MESSAGE_TYPE.INFO, message: localizer.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')};
      return;
    }

    var isFieldInvisibleOrUnfilterable = store.isFieldInvisibleOrUnfilterable();
    var savePromise = Promise.resolve();

    if (isFieldInvisibleOrUnfilterable) {
      savePromise = props.confirmFn('Confirmation', {
        description: querySourceTypeConstants.BUNDLE.MESSAGE.MG03
      });
    }

    savePromise.then(function () {
      loader.startLoading();
      store.updateQuerySource().then(function (response) {
        if (!response.success) {
          valManager.reset();
          valManager.updateErrors(response.messages);
        } else {
          // reload right
          store.resetData();
          store.loadQuerySources();
          // reload indicator middle
          props.parentStore.loadIndicator();
          // reload indicator left
          uiState.increaseDetectChangeCount();
          // update alert message
          store.alertMessage = { type: CommonMessages.MESSAGE_TYPE.SUCCESS, message: localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED') };
        }
      }).finally(loader.endLoading.bind(loader));
    }, function () {
      store.reload();
    });
  }

  function onSearch (props, searchProperty, searchText) {
    var store = props.store;
    var loader = props.loader;

    props.updateSearchProperty(searchProperty);
    props.updateSearchValue(searchText);

    return props.confirmDirtyForm(store.hasChange)
      .then(function () {
        loader.startLoading();
        store.search(searchProperty, searchText)
          .finally(loader.endLoading.bind(loader));
      });
  }

  function onCancel (props, event) {
    var store = props.store;
    var loader = props.loader;

    props.confirmDirtyForm(store.hasChange)
      .then(loader.startLoading.bind(loader))
      .then(store.reload.bind(store))
      .finally(loader.endLoading.bind(loader));
  }

  function isNotHighLight (props, field) {
    return props.searchProperty === 'All' ? false : props.searchProperty !== field;
  }

  module.exports = actions;
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.QuerySourceTypeActions.js